import { render, staticRenderFns } from "./borrowingList.vue?vue&type=template&id=0f56117e&scoped=true"
import script from "./borrowingList.vue?vue&type=script&lang=js"
export * from "./borrowingList.vue?vue&type=script&lang=js"
import style0 from "./borrowingList.vue?vue&type=style&index=0&id=0f56117e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f56117e",
  null
  
)

export default component.exports